import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetUsers } from './useGetUsers/useGetUsers';
export const UsersFilter = withFilterErrorBoundary((props) => {
    const { name, label } = props;
    const { data, error, loading } = useGetUsers();
    const disabled = Boolean(loading || error);
    return <SearchStringFilter name={name} items={data} label={label} loading={disabled}/>;
});
